module.exports = __webpack_public_path__ + "static/media/myTransporter-banner.355fc28a.jpg";